<template>
  <div :class="s.wrap">
    <ul
      v-if="items.length"
      :class="s.items">
      <li
        v-for="(item, i) in items"
        :key="i"
        :class="[
          i === 0 ? s.isActive : '',
        ]"
        @click="jump2Section(item.name)"
      >{{ item.label }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'menu-bar',
  data() {
    return {
      type: null,
      pages: [
        {
          path: '/shien',
          items: [
            {
              name: 'window',
              label: '支援窓口・体制',
            },
            {
              name: 'support',
              label: '支援制度',
            },
          ],
        },
        {
          path: '/kaigyou',
          items: [
            {
              name: 'charm',
              label: '魅力',
            },
            {
              name: 'topics',
              label: '産地トピックス',
            },
            {
              name: 'empty-shop',
              label: '空き店舗紹介',
            },
            {
              name: 'organization',
              label: '支援機関',
            },
            {
              name: 'support',
              label: '支援制度',
            },
            {
              name: 'interview',
              label: '産地インタビュー',
            },
          ],
        },
        {
          path: '/about',
          // nameは views/About/index.vue のセクションidと対応している。
          // ズレてもエラーにならずクリックが無反応になるだけのため、改名時は必ず両方を同時に更新する
          items: [
            {
              name: 'about',
              label: '基本情報',
            },
            {
              name: 'charm',
              label: '産地の特長・魅力',
            },
          ],
        },
        {
          path: '/sumu',
          items: [
            {
              name: 'merit',
              label: '魅力',
            },
            {
              name: 'topics',
              label: '産地トピックス',
            },
            {
              name: 'find-house',
              label: '住まいを探す',
            },
            {
              name: 'support',
              label: '支援制度',
            },
            {
              name: 'interview',
              label: '産地インタビュー',
            },
          ],
        },
        {
          path: '/hataraku',
          items: [
            {
              name: 'charm',
              label: '魅力',
            },
            {
              name: 'topics',
              label: '産地トピックス',
            },
            {
              name: 'find-work',
              label: '多様な働き方',
            },
            {
              name: 'support',
              label: '支援制度',
            },
            {
              name: 'interview',
              label: '産地インタビュー',
            },
          ],
        },
        {
          path: '/kosodate',
          items: [
            {
              name: 'charm',
              label: '魅力',
            },
            {
              name: 'topics',
              label: '産地トピックス',
            },
            {
              name: 'education',
              label: '桐生ならではの教育',
            },
            {
              name: 'various-education',
              label: '新たな学びの場',
            },
            {
              name: 'support',
              label: '支援制度・遊べる施設',
            },
            {
              name: 'interview',
              label: '産地インタビュー',
            },
          ],
        },
      ],
    };
  },
  computed: {
    currentPage() {
      return this.pages.find((p) => this.$route.path.includes(p.path));
    },
    items() {
      return this.currentPage?.items || [];
    },
  },
  methods: {
    jump2Section(name) {
      // queryは流入計測等で使われるため引き継ぐ
      this.$router.replace({ path: this.$route.path, query: this.$route.query, hash: `#${name}` });
      const elem = document.getElementById(name);
      if (elem) {
        const rect = elem.getBoundingClientRect();
        const offsetTop = window.pageYOffset + rect.top;
        window.scrollTo({ top: offsetTop });
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  display: flex;
  justify-content: center;
}
.items {
  display: flex;
  padding: 28px 48px;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  border-radius: 100px;
  > li {
    font-size: 14px;
    color: #000000;
    opacity: .5;
    cursor: pointer;
    white-space: nowrap;

    &:not(:first-child) {
      margin-left: 48px;
    }

    &.isActive {
      opacity: 1;
      font-weight: 700;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        $wh: 8px;
        left: calc(-6px - $wh);
        top: 50%;
        transform: translate(0%, -50%);
        border-radius: $wh;
        width: $wh;
        height: $wh;
        background-color: var(--label-primary);
      }
    }
  }
}
@include smView {
  .wrap {
    width: 100%;
  }
  .items {
    margin: 0 auto;
    flex-flow: column;
    align-items: center;
    border-radius: 28px;
    > li {
      display: inline-block;
      &:not(:first-child) {
        margin-top: 12px;
        margin-left: 0;
      }
    }
  }
}
</style>
